import { HTMLAttributes, CSSProperties } from 'react';
import { TestIdProps } from '../../util/testId';
import { IconProps } from '../Icon';

/**
 * Extends the Icon props but restricts props to "'icon' | 'tooltip' | 'ariaHidden'"
 */
export interface HeadingIcon extends Pick<IconProps, 'icon' | 'tooltip' | 'ariaHidden'> {}

export enum HeadingVariant {
  Standard = 'standard',
  PrimaryLight = 'primary-light',
}

export interface HeadingProps extends TestIdProps, HTMLAttributes<HTMLHeadingElement> {
  className?: string;
  style?: CSSProperties;
  level: 1 | 2 | 3 | 4 | 5 | 6;
  variant?: HeadingVariant;
  /**
   * The heading text
   */
  children?: string;
  /**
   * @default false
   */
  wrapText?: boolean;
  /**
   * An optional icon to be added in front of the heading text
   */
  icon?: HeadingIcon;
  id?: string;
  /**
   * @default false
   */
  focusable?: boolean;
  disabled?: boolean;
  textProps?: HTMLAttributes<HTMLSpanElement>;
}
